import React, {Component} from 'react';
import {connect} from 'react-redux';
import NoticeTable from './NoticeTable';
import {Route} from 'react-router-dom';
import NoticeDetail from './NoticeDetail';
import {PageContainer, PageDescription, PageTitle} from '../../Common/PageComponents';

class Notices extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="공지사항" data-qa="noticePageTitle" />
        <PageDescription>라이엇 게임즈와 관련된 빠르고 정확한 뉴스를 알려드립니다.</PageDescription>
        <Route exact path="/news/notices" component={NoticeTable} />
        <Route exact path="/news/notices/:pageNumber" component={NoticeTable} />
        <Route exact path="/news/notices/details/:noticeId" component={NoticeDetail} />
      </PageContainer>
    );
  }
}

export default connect()(Notices);
